import { render, staticRenderFns } from "./distributorWithdraw.vue?vue&type=template&id=0128a375&"
import script from "./distributorWithdraw.vue?vue&type=script&lang=js&"
export * from "./distributorWithdraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports